import React from "react"
import DynamicCarousel from "./DynamicCarousel"
import OriginalCarousel from "./Carousel"

interface CarouselProps {
  spacing?: number
  items: Array<any>
  itemCount: number
  type?: string
  showDragIcon?: boolean
  disableDragDrop?: boolean
  dragEndCallback?: Function
  addBlockFlag?: boolean
  addCallback?: Function
  deleteBlockFlag?: boolean
  deleteCallBack?: Function
  uploadFileFlag?: boolean
  uploadFileCallback?: Function
  itemWidth?: number
  maxWidth?: number
  left?: number
  version?: string
  /**
   * An ID used for testing purposes applied as a data attribute (data-test-id)
   */
  testId?: string
  dynamicWidth?: boolean;
}

const Carousel = (props : CarouselProps) => {
    const dynamicProps = {
        items: props.items,itemCount: props.itemCount,showDragIcon: props.showDragIcon,disableDragDrop: props.disableDragDrop,dragEndCallback: props.dragEndCallback,addCallback: props.addCallback,deleteCallBack: props.deleteCallBack,type : props.type,dynamicWidth: props.dynamicWidth 
    }
    if(props.dynamicWidth){
        return <DynamicCarousel {...dynamicProps}/>
    }
    // send every prop to OriginalCarousel except dynamicWidth
    return <OriginalCarousel {...props} />
}

export default Carousel;